import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

import {
  PresidioQuoteCartGuardService,
  PresidioQuoteCartPending,
} from '../../services/presidio-quote-cart-guard/presidio-quote-cart-guard.service';

/**
 * CUSTOMIZATION: Global confirm when catalog ATC (or SFL→cart) conflicts with a quote in cart (FR13.7.5).
 */
@Component({
  selector: 'ish-presidio-quote-cart-sfl-modal',
  templateUrl: './presidio-quote-cart-sfl-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, TranslatePipe, ModalDialogComponent],
})
export class PresidioQuoteCartSflModalComponent {
  private guard = inject(PresidioQuoteCartGuardService);

  @ViewChild('catalogToSflModal') catalogToSflModal: ModalDialogComponent<unknown>;
  @ViewChild('sflBlockedModal') sflBlockedModal: ModalDialogComponent<unknown>;

  readonly pending$ = this.guard.pending$;
  private catalogConfirmed = false;

  constructor() {
    this.guard.pending$
      .pipe(
        filter((p): p is PresidioQuoteCartPending => !!p),
        takeUntilDestroyed()
      )
      .subscribe(pending => {
        this.catalogConfirmed = false;
        queueMicrotask(() => {
          if (pending.kind === 'catalog_to_sfl') {
            this.catalogToSflModal?.show();
          } else {
            this.sflBlockedModal?.show();
          }
        });
      });
  }

  onCatalogConfirm(): void {
    this.catalogConfirmed = true;
    this.guard.confirmCatalogToSaveForLater();
  }

  onCatalogClosed(): void {
    if (!this.catalogConfirmed) {
      this.guard.cancel();
    }
    this.catalogConfirmed = false;
  }

  onBlockedClosed(): void {
    this.guard.cancel();
  }

  itemCount(pending: PresidioQuoteCartPending | null): number {
    return pending?.kind === 'catalog_to_sfl' ? pending.items.length : 0;
  }
}
